<template>
  <div id="app">
    <v-app>
      <template v-if="displayNavs">
        <LeftNav :open="leftNav"></LeftNav>
        <TopNav @right-nav-toggle="rightNav = !rightNav" @left-nav-toggle="leftNav = !leftNav"></TopNav>
        <RightNav :open="rightNav"></RightNav>
      </template>
      <v-content class>
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-content>
      <spinner></spinner>
      <Snackbar></Snackbar>
    </v-app>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  components: {
    TopNav: () => import('@/components/layout/TopNav'),
    LeftNav: () => import('@/components/layout/LeftNav'),
    RightNav: () => import('@/components/layout/RightNav'),
    Spinner: () => import('@/components/custom-components/BlockSpinner'),
    Snackbar: () => import('@/components/custom-components/snackbar/snackbar.vue')
  },
  data () {
    return {
      leftNav: true,
      rightNav: false
    }
  },
  methods: {},
  computed: {
    ...mapGetters({
      vg_user: 'auth/user'
    }),
    isLoggedIn () {
      let user = this.vg_user
      if (!user || user === undefined || user === '') {
        return false
      }
      return true
    },
    displayNavs () {
      return this.isLoggedIn && !this.isLoginRoute
    },
    isLoginRoute () {
      return this.$route.name === 'Login'
    }
  }
}
</script>
